import React, { useRef, useEffect } from 'react';

function VideoModal({ open, onClose, src, width = 3460, height = 1800 }) {
  const videoRef = useRef(null);

  useEffect(() => {
    if (!open && videoRef.current) {
      videoRef.current.pause();
      videoRef.current.currentTime = 0;
    }
  }, [open]);

  // 영상 끝나면 모달 닫기
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const handleEnded = () => onClose();
    video.addEventListener('ended', handleEnded);
    return () => video.removeEventListener('ended', handleEnded);
  }, [onClose]);

   useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (open) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [open, onClose]);
  
  if (!open) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        right: '50%',
        width: `${width}px`,
        height: `${height}px`,
        transform: 'translate(25%, -50%)',
        backgroundColor: 'black',
        zIndex: 9999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      onClick={onClose}
    >
      <button
        onClick={onClose}
        style={{
          position: 'absolute',
          top: 10,
          right: 10,
          background: 'rgba(0,0,0,0.5)',
          color: 'white',
          border: 'none',
          fontSize: '4rem',
          cursor: 'pointer',
          padding: '4px 10px',
          borderRadius: '4px',
        }}
      >
        ×
      </button>

      <video
        ref={videoRef}
        src={src}
        controls
        autoPlay
        style={{
          maxWidth: '100%',
          height: '100%',
        }}
        onClick={(e) => e.stopPropagation()} // 클릭 이벤트 전파 방지
      />
    </div>
  );
}

export default VideoModal;



// import React, { useRef, useEffect } from 'react';

// function VideoModal({ open, onClose, src, width = 1200, height = 720 }) {
//   const videoRef = useRef(null);

//   useEffect(() => {
//     if (!open && videoRef.current) {
//       videoRef.current.pause();
//       videoRef.current.currentTime = 0;
//     }
//   }, [open]);

//   useEffect(() => {
//     const video = videoRef.current;
//     if (!video) return;
//     const handleEnded = () => onClose();
//     video.addEventListener('ended', handleEnded);
//     return () => video.removeEventListener('ended', handleEnded);
//   }, [onClose]);

//   if (!open) return null;

//   return (
//     <div
//        style={{
//         position: 'fixed',
//         top: '50%',
//         right: '50%',
//         width: `${width}px`,
//         height: `${height}px`,
//         transform: 'translate(25%, -50%)',
//         backgroundColor: 'black',
//         zIndex: 9999,
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//       }}
//     >
//       {/* X 버튼 */}
//       <button
//         onClick={onClose}
//         style={{
//           position: 'absolute',
//           top: 10,
//           right: 10,
//           background: 'rgba(0,0,0,0.5)',
//           color: 'white',
//           border: 'none',
//           fontSize: '1.5rem',
//           cursor: 'pointer',
//           padding: '4px 10px',
//           borderRadius: '4px',
//         }}
//       >
//         ×
//       </button>

//       {/* 영상 영역 */}
//       <video
//         ref={videoRef}
//         src={src}
//         controls
//         autoPlay
//         style={{
//           maxWidth: '100%',
//           maxHeight: '100%',
//         }}
//         onClick={(e) => e.stopPropagation()} // 클릭 이벤트 전파 방지
//       />
//     </div>
//   );
// }

// export default VideoModal;
